module.exports = __webpack_public_path__ + "images/share-image_v1.7ba9b442.png";